<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.process.name | translate }} - {{ editedEntity.datasource.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("common.create") }}</span>
      </h2>

      <filter-select
        class="mt-4"
        id="process-datasource-process-filter"
        ref="process-datasource-process-filter"
        :placeholder="$t('process.select')"
        :multiple="true"
        :isValid="!$v.form.process.$invalid"
        :displayCount="3"
        @filter="onProcessSearch"
        :selected="form.process"
        @changed="processSelect"
        track="_id"
      />
      <filter-select
        class="mt-4"
        id="process-datasource-datasource-filter"
        ref="process-datasource-datasource-filter"
        :placeholder="$t('datasource.select')"
        :multiple="true"
        :isValid="!$v.form.datasource.$invalid"
        :displayCount="3"
        @filter="onDatasourceSearch"
        :selected="form.datasource"
        @changed="datasourceSelect"
        track="_id"
      />

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
const state = "processDatasource";

export default {
  props: ["state"],
  data() {
    return {
      form: { process: undefined, datasource: undefined },
    };
  },
  validations: {
    form: {
      process: {
        required,
      },
      datasource: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceProcessDatasource";
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${this.state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${this.state}/isEditMode`];
    },
  },
  async mounted() {
    this.state = this.state || state;
  },
  methods: {
    async save() {
      const processes = this.form.process;
      const childDatasources = this.form.datasource;
      this.$emit("onSave", processes, childDatasources);
    },

    async onProcessSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceProcess" : "managementProcess";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }) },
      });
      callback(response.data?.docs ?? []);
    },
    processSelect(item) {
      this.form = { ...this.form, process: item };
    },
    async onDatasourceSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDatasource" : "managementDatasource";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }) },
      });
      callback(response.data?.docs ?? []);
    },
    datasourceSelect(item) {
      this.form = { ...this.form, datasource: item };
    },
  },
};
</script>
